export const API_URL = process.env.REACT_APP_API_URL;
export const FRONT_API_URL = process.env.REACT_APP_FRONT_API_URL;
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
